module.exports = __webpack_public_path__ + "src/assets/static/img/footer-brand-2.af9e8765.png";